import React, { useEffect, useState } from "react";
import "react-quill-new/dist/quill.snow.css";
import "../Services/Services.css";
import CharIcon from "../../Assets/img/word.png";
import Loading from "../../Loading/loading";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import UploadIcon from "../../Assets/img/upload.png";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import API from "../Service/Baseservice";
import OurMissionPreview from "./OurMissionPreview";
const aboutMap = { 1: 2, 2: 7 }; // English → 2, French → 7

const OurMissionEdit = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const location = useLocation();

    const languageId = Number(new URLSearchParams(location.search).get("lang")) || 1;
    const [showPreviewOurMission, setShowPreviewOurMission] = useState(false);
    const [previewData, setPreviewData] = useState(null);
    const [loading, setLoading] = useState(true);

    const [missionImage, setMissionImage] = useState(null);
    const [popup, setPopup] = useState({
        show: false,
        title: "",
        message: "",
        type: "",
    });
    const [formData, setFormData] = useState({
        ourmission_id: "",
        language_id: languageId,
        about_id: aboutMap[languageId],
        heading: "",
        title: "",
        description: "",
        mission_image: "",
        updatedBy: 1,
        missionsData: [
            { section_id: 1, heading: "", description: "" },
            { section_id: 2, heading: "", description: "" },
            { section_id: 3, heading: "", description: "" },
            { section_id: 4, heading: "", description: "" }
        ]
    });

    const getPlainTextLength = (html) => {
        const div = document.createElement("div");
        div.innerHTML = html;
        return (div.textContent || div.innerText || "").length;
    };

    useEffect(() => {
        setLoading(true);

        const payload = {
            language_id: languageId,
            about_id: Number(id),
        };

        API.post("list_ourmission/condition", payload)
            .then((res) => {
                const list = res.data?.data?.data;

                if (list && list.length > 0) {
                    const mission = list[0];

                    const sorted = (mission.sections || []).sort((a, b) => a.section_id - b.section_id);

                    setFormData({
                        ourmission_id: mission.ourmission_id,
                        language_id: mission.language_id,
                        about_id: mission.about_id,
                        heading: mission.heading || "",
                        title: mission.title || "",
                        description: mission.description || "",
                        mission_image: mission.mission_image || "",
                        updatedBy: 1,
                        missionsData: sorted.length > 0 ? sorted : [
                            { section_id: 1, heading: "", description: "" },
                            { section_id: 2, heading: "", description: "" },
                            { section_id: 3, heading: "", description: "" },
                            { section_id: 4, heading: "", description: "" }
                        ]
                    });

                    setMissionImage(mission.mission_image);
                } else {

                    setFormData({
                        ourmission_id: "",
                        language_id: languageId,
                        about_id: Number(id),
                        heading: "",
                        title: "",
                        description: "",
                        mission_image: "",
                        updatedBy: 1,
                        missionsData: [
                            { section_id: 1, heading: "", description: "" },
                            { section_id: 2, heading: "", description: "" },
                            { section_id: 3, heading: "", description: "" },
                            { section_id: 4, heading: "", description: "" }
                        ]
                    });

                    setMissionImage(null);
                }
            })
            .finally(() => setLoading(false));
    }, [languageId, id]);


    // ---------------- IMAGE UPLOAD ----------------
    const handleImageUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            setMissionImage(URL.createObjectURL(file));
            setFormData({ ...formData, mission_image: file });
        }
    };

    const handleUpdate = () => {
        if (!formData.heading.trim()) {
            return setPopup({
                show: true,
                title: "Required",
                message: "Heading is required!",
                type: "info",
            });
        }

        if (!formData.title.trim()) {
            return setPopup({
                show: true,
                title: "Required",
                message: "Title is required!",
                type: "info",
            });
        }

        if (!formData.description.trim()) {
            return setPopup({
                show: true,
                title: "Required",
                message: "Description is required!",
                type: "info",
            });
        }

        if (!formData.mission_image) {
            return setPopup({
                show: true,
                title: "Required",
                message: "Mission image is required!",
                type: "info",
            });
        }

        for (let m of formData.missionsData) {
            if (!m.heading.trim() || !m.description.trim()) {
                return setPopup({
                    show: true,
                    title: "Required",
                    message: "All mission card fields are required!",
                    type: "info",
                });
            }
        }

        setLoading(true);

        let updateData = { ...formData };

        const uploadImageAndUpdate = (base64Image) => {
            const payload = {
                name: "Mission Image",
                image: [{
                    name: formData.mission_image.name,
                    type: formData.mission_image.type,
                    size: formData.mission_image.size,
                    base64: base64Image
                }]
            };

            return API.post("imageUpload/add", payload).then((res) => res.data.url);
        };

        const updateMission = () => {
            API.post("ourmission_edit/update", updateData)
                .then(() => {
                    setPopup({
                        show: true,
                        title: "Success",
                        message: "Mission updated successfully!",
                        type: "success",
                    });
                })
                .catch(() =>
                    setPopup({
                        show: true,
                        title: "Error",
                        message: "Failed to update mission!",
                        type: "error",
                    })
                )
                .finally(() => setLoading(false));
        };


        if (formData.mission_image instanceof File) {
            convertToBase64(formData.mission_image)
                .then(uploadImageAndUpdate)
                .then((url) => {
                    updateData.mission_image = url;
                    updateMission();
                })
                .catch(() =>
                    setPopup({
                        show: true,
                        title: "Error",
                        message: "Image upload failed!",
                        type: "error",
                    })
                );
        } else {
            updateMission();
        }
    };


    const convertToBase64 = (file) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (err) => reject(err);
        });

    const handlePreview = () => {

        // BASIC VALIDATION
        if (!formData.heading.trim()) {
            return setPopup({
                show: true,
                title: "Required",
                message: "Heading is required for preview!",
                type: "info",
            });
        }

        if (!formData.title.trim()) {
            return setPopup({
                show: true,
                title: "Required",
                message: "Title is required for preview!",
                type: "info",
            });
        }

        if (!formData.description.trim()) {
            return setPopup({
                show: true,
                title: "Required",
                message: "Description is required for preview!",
                type: "info",
            });
        }

        // SECTIONS VALIDATION (FIX: use missionsData)
        for (let sec of formData.missionsData) {
            if (!sec.heading.trim() || !sec.description.trim()) {
                return setPopup({
                    show: true,
                    title: "Required",
                    message: "All mission card fields are required!",
                    type: "info",
                });
            }
        }

        setPreviewData({
            heading: formData.heading,
            title: formData.title,
            description: formData.description,
            missionsData: formData.missionsData,
            mission_image: missionImage
        });

        setShowPreviewOurMission(true);
    };
    const MAX_CHARS = 4000;
    const [lastValidDescription, setLastValidDescription] = useState("");

    return (
        <div className="newss-containeradd">

            <div className="service-header-bar">
                <h2 className="services-title1">Edit Our Mission</h2>

                <div className="button-group">
                    <div className="filter-block">
                        <label>Language</label>
                        <div className="input-container">
                            <select
                                className="input-field"
                                value={languageId}
                                onChange={(e) => {
                                    const newLang = Number(e.target.value);
                                    navigate(`/ourmissionedit/${aboutMap[newLang]}?lang=${newLang}`, { replace: true });
                                }}
                            >
                                <option value={1}>English</option>
                                <option value={2}>Français</option>
                            </select>
                        </div>
                    </div>
                    <button onClick={handlePreview} className="language-save-btn">
                        Preview
                    </button>
                    <button className="language-save-btn" onClick={handleUpdate}>
                        Save
                    </button>
                    <button className="language-cancel-btn " onClick={() => navigate("/aboutus")}>
                        Back
                    </button>
                </div>
            </div>
            {loading ? (
                <Loading />
            ) : (
                <>
                    <div className="ourstoryedit-container">

                        {/* ---- MAIN HEADING ---- */}
                        <div className="aboutus-form-group ourstory-full-width">
                            <label>Heading <span className="required">*</span></label>
                            <input
                                type="text"
                                value={formData.heading}
                                onChange={(e) => setFormData({ ...formData, heading: e.target.value })}
                            // maxLength={70}
                            />
                        </div>

                        {/* LEFT FORM BLOCK */}
                        <div className="ourstory-left-form">

                            <div className="aboutus-form-group">
                                <label>Title <span className="required">*</span></label>
                                <input
                                    type="text"
                                    value={formData.title}
                                    onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                                // maxLength={250}
                                />
                            </div>

                            <div className="news-form-group ourmission-editor-small">
                                <label className="news-description-label">
                                    <span>Description <span className="required">*</span></span>
                                    <div className="char-wrapper">
                                        <img src={CharIcon} alt="Character count" />
                                        <span className="char-count">{getPlainTextLength(formData.description)}/4000</span>
                                    </div>
                                </label>

                                <CKEditor
                                    editor={ClassicEditor}
                                    data={formData.description}
                                    onReady={(editor) => {
                                        setLastValidDescription(editor.getData());
                                    }}
                                    onChange={(event, editor) => {
                                        const html = editor.getData();

                                        // Convert HTML → plain text
                                        const div = document.createElement("div");
                                        div.innerHTML = html;
                                        const text = div.textContent || "";

                                        if (text.length <= MAX_CHARS) {
                                            // ✅ Allow typing & backspace
                                            setLastValidDescription(html);
                                            setFormData({ ...formData, description: html });
                                        } else {
                                            // ❌ Block extra typing but keep backspace working
                                            editor.setData(lastValidDescription);
                                        }
                                    }}
                                    config={{
                                        toolbar: [
                                            "undo", "redo", "|",
                                            "heading", "|",
                                            "bold", "italic", "underline", "|",
                                            "bulletedList", "numberedList",
                                        ],
                                    }}
                                />

                            </div>

                            {formData.missionsData.map((sec, index) => {
                                if (index === 1 || index === 3) return null; // these go to right block
                                return (
                                    <React.Fragment key={index}>
                                        <div className="aboutus-form-group">
                                            <label>Card {index + 1} <span className="required">*</span></label>
                                            <input
                                                type="text"
                                                value={sec.heading}
                                                onChange={(e) => {
                                                    const upd = [...formData.missionsData];
                                                    upd[index].heading = e.target.value;
                                                    setFormData({ ...formData, missionsData: upd });
                                                }}
                                            />
                                        </div>

                                        <div className="news-form-group ourmission-editor-small">
                                            <label className="news-description-label">
                                                <span>Description <span className="required">*</span></span>
                                            </label>
                                            <CKEditor
                                                editor={ClassicEditor}
                                                data={sec.description}
                                                onChange={(event, editor) => {
                                                    const upd = [...formData.missionsData];
                                                    upd[index].description = editor.getData();
                                                    setFormData({ ...formData, missionsData: upd });
                                                }}
                                                config={{
                                                    toolbar: [
                                                        "undo", "redo", "|",
                                                        "heading", "|",
                                                        "bold", "italic", "underline", "|",
                                                        "bulletedList", "numberedList",
                                                    ],
                                                }}
                                            />
                                        </div>
                                    </React.Fragment>
                                );
                            })}
                        </div>

                        {/* --- RIGHT SIDE --- */}
                        <div className="ourstory-right-section">

                            <div className="upload-section">
                                <label>Upload Image <span className="required">*</span></label>
                                <div className="ourmission-upload-box">
                                    {missionImage ? (
                                        <img src={missionImage} alt="Preview" className="preview-img" />
                                    ) : (
                                        <>
                                            <img src={UploadIcon} alt="Upload" className="upload-icon" />
                                            <p>Click to upload</p>
                                        </>
                                    )}
                                    <input type="file" accept="image/*" onChange={handleImageUpload} />
                                </div>
                            </div>

                            {formData.missionsData.map((sec, index) => {
                                if (index === 0 || index === 2) return null; // already placed left
                                return (
                                    <React.Fragment key={index}>
                                        <div className="aboutus-form-group">
                                            <label>Card {index + 1} <span className="required">*</span></label>
                                            <input
                                                type="text"
                                                value={sec.heading}
                                                onChange={(e) => {
                                                    const upd = [...formData.missionsData];
                                                    upd[index].heading = e.target.value;
                                                    setFormData({ ...formData, missionsData: upd });
                                                }}
                                            />
                                        </div>

                                        <div className="news-form-group ourmission-editor-small">
                                            <label className="news-description-label">
                                                <span>Description <span className="required">*</span></span>
                                            </label>
                                            <CKEditor
                                                editor={ClassicEditor}
                                                data={sec.description}
                                                onChange={(event, editor) => {
                                                    const upd = [...formData.missionsData];
                                                    upd[index].description = editor.getData();
                                                    setFormData({ ...formData, missionsData: upd });
                                                }}
                                                config={{
                                                    toolbar: [
                                                        "undo", "redo", "|",
                                                        "heading", "|",
                                                        "bold", "italic", "underline", "|",
                                                        "bulletedList", "numberedList",
                                                    ],
                                                }}
                                            />
                                        </div>
                                    </React.Fragment>
                                );
                            })}
                        </div>

                    </div>
                </>
            )}
            {popup.show && (
                <div className="popup-overlay">
                    <div className={`popup-box popup-${popup.type}`}>
                        <h3>{popup.title}</h3>
                        <p>{popup.message}</p>
                        <button
                            className="btn ok-btn"
                            onClick={() => {
                                setPopup({ ...popup, show: false });

                                if (popup.type === "success") {
                                    navigate("/aboutus");
                                }
                            }}
                        >
                            OK
                        </button>

                    </div>
                </div>
            )}
            {showPreviewOurMission && (
                <OurMissionPreview
                    previewService={previewData}
                    setShowPreviewOurMission={setShowPreviewOurMission}
                />
            )}
        </div>
    );
};

export default OurMissionEdit;
